import { render, staticRenderFns } from "./BaseVideo.vue?vue&type=template&id=470f721c&scoped=true&"
import script from "./BaseVideo.vue?vue&type=script&lang=ts&"
export * from "./BaseVideo.vue?vue&type=script&lang=ts&"
import style0 from "./BaseVideo.vue?vue&type=style&index=0&id=470f721c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f721c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
